export const defaultCustomColumnName = 'customColumn1';
